import React, { useEffect, useRef } from "react";
import { Redirect, Route } from "react-router-dom";

import PropTypes from "prop-types";
import ROUTES from "Constants/routes";

import AnalyticsService from "Services/analytics";

const RouteContainer = ({
  component: Component,
  Authorized,
  gtmEventCategory,
  isNeedAuthorization,
  ...rest
}) => {
  const trackingRef = useRef({
    gtmEventCategory,
    pathname: rest.location.pathname,
  });

  useEffect(() => {
    const { gtmEventCategory, pathname } = trackingRef.current;

    if (gtmEventCategory) {
      AnalyticsService.trackPageEventCategory(gtmEventCategory);
    }

    AnalyticsService.trackPageView(pathname);
  }, []);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isNeedAuthorization && !Authorized) {
          return (
            <Redirect
              to={{
                pathname: ROUTES.SIGN_IN,
                state: { from: props.location, referrer: props.location },
              }}
            />
          );
        }
        if (!isNeedAuthorization && Authorized) {
          const route =
            props.location.state && props.location.state.referrer
              ? props.location.state.referrer
              : {
                  pathname: !!localStorage.getItem("isFirstVisit")
                    ? ROUTES.STATISTICS.BASE
                    : ROUTES.WELCOME,
                  state: { from: props.location },
                };

          return <Redirect to={route} />;
        }

        return <Component isAuthenticated={Authorized} {...props} />;
      }}
    />
  );
};

RouteContainer.propTypes = {
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.elementType])
    .isRequired,
  Authorized: PropTypes.bool.isRequired,
  isNeedAuthorization: PropTypes.bool.isRequired,
  gtmEventCategory: PropTypes.string,
  location: PropTypes.object,
};

RouteContainer.defaultProps = {
  gtmEventCategory: undefined,
  location: undefined,
};

export default RouteContainer;
